// fullFaceBotoxData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const nabotaBotox: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} = {
    "en": {
        "url": "",
        "meta": {
            "title": "Nabota Botox Dubai | Non-Surgical Wrinkle Reduction",
            "description": "We offer Nabota Botox in Dubai to reduce fine lines on the forehead, crowâ€™s feet, and frown lines. Non-surgical wrinkle reduction for youthful, smooth skin.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/nabota-botox/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Nabota Botox Dubai | Non-Surgical Wrinkle Reduction",
                "description": "We offer Nabota Botox in Dubai to reduce fine lines on the forehead, crowâ€™s feet, and frown lines. Non-surgical wrinkle reduction for youthful, smooth skin.",
                "url": "https://elitebodyhome.com/services/nabota-botox/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T09:11:06+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fgjgyi-scaled-large.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fgjgyi-scaled-large.jpg",
                "image_width": 1024,
                "image_height": 572,
                "image_alt": "Nabota Botox",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Nabota Botox Dubai | Non-Surgical Wrinkle Reduction",
                "description": "We offer Nabota Botox in Dubai to reduce fine lines on the forehead, crowâ€™s feet, and frown lines. Non-surgical wrinkle reduction for youthful, smooth skin.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fgjgyi-scaled-large.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Nabota Botox"],
        "hero": {
            "title": "Nabota Botox Treatment in Dubai",
            "subtitle": "Your Go-to Choice for a Super-Fresh Appearance",
            "description": "Look younger than ever before! Wrinkles, skin issues, and other indications of aging typically appear after a certain age. Enjoy a naturally gorgeous appearance and bid adieu to all skin problems. With our Nabota Botox treatment, which is a one-stop shop for reducing wrinkles by relaxing muscles, we at Elite Body Home have you covered."
        },
        "howItWorks": {
            "title": "What is Nabota Botox and How It work?",
            "description": "Nabota Botox works well for treating muscular disorders and wrinkles. of essence, it's a transparent version of Botulinum Toxin that primarily affects the muscles of the face, resulting in dynamic wrinkles. We all have lines on our faces, including foreheads and frowns. Its primary purpose is to smooth out all of the lines in the facial expressions above. In Dubai, Nabota Botox therapy is well-liked and frequently used. We have a team of experts at Elite Body Home who can do the treatment for you!"
        },
        "procedureSteps": {
            "heading": "Steps for Nabota Botox Treatment Procedure",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "The initial step is consultation, wherein your face is studied carefully. Then a proper treatment plan is created accordingly that's well suited for your face features, needs and goals.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation",
                    "desc": "Thereafter, the area of treatment is cleaned properly and a numbing cream is applied. Accuracy is important in every matter and thus when it comes to injection. Here we mark the points carefully.",
                    "icon": "fa-solid fa-prescription-bottle-medical"
                },
                {
                    "title": "Injections",
                    "desc": "Now using a very fine needle, it comes to injecting the injection in the targeted areas. This usually takes around 15 to 30 minutes.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Aftercare Application",
                    "desc": "The step does not end here, a serum is applied to make the skin softer.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Nabota Botox",
            "subheading": "Nabota Botox full face treatment is your go to choice for enjoying a glowy and young look without worrying about the aging problems. Below are the benefits that clears the concept more.",
            "para": "",
            "items": [
                {
                    "title": "Make Wrinkles Smooth",
                    "desc": "Wrinkles are a big problem nowadays. With Nabota Botox treatment in Dubai you can reduce the wrinkles and get an amazing young look.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "No New Wrinkles",
                    "desc": "Here with this treatment, one of the remarkable benefits is there are now new wrinkles, as the muscles that react more are relaxed, preventing formation of expression lines.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Non-Surgical, Convenient",
                    "desc": "You don't need to go under any surgery. Just a simple procedure that delivers outstanding results in less time.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "Get the Fastest Results",
                    "desc": "No more waiting for a longer time. Get the results within just a few days. Further, they last for around 4-6 months.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Take Confidence to Next Level",
                    "desc": "Excel both in personal and professional life. With a look that's amazing you can skyrocket your confidence level.",
                    "icon": "fa-solid fa-arrow-up"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "For whom is Nabota Botox beneficial?",
            "para": "There are no specific requirements. However, some need to obtain a boost and restore a remarkable look that keeps aging at bay.",
            "items": [
                {
                    "title": "Option Without Surgery",
                    "desc": "Perfect for someone who wants excellent skin results without having to have any surgery.",
                    "icon": "fa-solid fa-hand"
                },
                {
                    "title": "Organic Outcomes",
                    "desc": "Maintain your face's natural expression. Savor the same as previously while fully embracing the new style.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Tailored Care",
                    "desc": "Everybody has diverse tastes in aesthetics. All of the necessities are met in one location at Elite Body Home.",
                    "icon": "fa-solid fa-user-gear"
                }
            ]
        },
        "preparationTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "results": {
            "heading": "Experience the Stand-Out Results",
            "subheading": "You may count on the greatest Nabota Botox treatment at Elite Body Home. Rejuvenate your skin and achieve a more youthful appearance without altering your facial expressions. The best outcomes are listed below.",
            "para": "",
            "items": [
                {
                    "title": "Skin that is clear and glossy",
                    "desc": "Reject creases around your eyes, brows, and other areas. Once you choose this treatment, they are drastically decreased.",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "Obtain Exceptionally Fast Results",
                    "desc": "Changes are typically noticeable three to five days following treatment, with the best effects appearing seven to ten days later.",
                    "icon": "fa-solid fa-gauge-high"
                },
                {
                    "title": "Long-Term Advantages",
                    "desc": "Depending on the patient's lifestyle and level of muscle activity, the results of a Nabota Botox treatment can last anywhere from four to six months, providing prolonged rejuvenation with little upkeep.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Free of wrinkles",
                    "desc": "It helps maintain youthful, attractive skin for a long period by preventing wrinkles brought on by aging.",
                    "icon": "fa-solid fa-face-grin-beam"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tips for Nabota Botox Treatment",
            "subheading": "Simply going for treatment is not enough. You need a proper aftercare to reduce the side affects and unleash the full results. Below are some of the essential tips that will surely help!",
            "para": "",
            "items": [
                {
                    "title": "Avoid Touching the Treated Area",
                    "desc": "Do not touch or message the treated area for atleast 24 hours.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "Stay in a Upper Position",
                    "desc": "To make sure the Botox is settled in the right way, try to follow an upright position for 4 hours.",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "Avoid Heavy Workouts",
                    "desc": "Do not exercise for a longer time as it can affect the potential results.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "No Consuming Alcohol for 24 Hours",
                    "desc": "Alcohol can increase the risk of bruising. So, not to consume alchol before and after the procedure.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Gentle Cleansing",
                    "desc": "Wash your face gently with a mild cleanser. Do not make any harsh movements or apply creams.",
                    "icon": "fa-solid fa-pump-soap"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "If you're considering Nabota Botox Treatment in Dubai, you may have questions about the procedure, results, and what to expect. Here are answers to common questions to help you make an informed decision.",
            "items": [
                {
                    question: "How quickly will I see results from Nabota Botox?",
                    answer:
                        "You will get to see the results generally appear within 3-5 days, with the full effect visible within a week.",
                },
                {
                    question: "Is there any downtime after this skin treatment?",
                    answer:
                        "Absolutely not! Most clients can return to their normal activities immediately after the procedure.",
                },
                {
                    question: "Can Nabota Botox help prevent new wrinkles?",
                    answer:
                        "Yes, it helps prevent new wrinkles by relaxing muscles that cause dynamic lines.",
                },
                {
                    question: "Are there any side effects of Nabota Botox?",
                    answer:
                        "Temporary redness or swelling may occur at the injection sites, but these effects usually fade within a few hours.",
                }
            ]
        },
        "treatmentAreas2": [
            {
                ar: "الخط الفكي",
                title: "Jawline",
                image: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-5.jpg"
            },
            {
                ar: "أشرطة العنق",
                title: "Neck Bands",
                image: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-6.jpg"
            },
            {
                ar: "خطوط الشفاه",
                title: "Lip Lines",
                image: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-1.jpg"
            }
        ],
        "treatmentAreas1": [
            {
                ar: "الجبهة",
                title: "Forehead",
                image: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-2.jpg"
            },
            {
                ar: "خطوط التجهم",
                title: "Frown Lines",
                image: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-3.jpg"
            },
            {
                ar: "خطوط الأرنب",
                title: "Bunny Lines",
                image: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-4.jpg"
            }
        ]
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fgjgyi-scaled-large.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-3.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-4.jpg"
            ]
        },
        "product": {
            "id": 7,
            "price": 199,
            "title": "Nabota Botox Treatment in Dubai",
            "description": "Look younger than ever before! Wrinkles, skin issues, and other indications of aging typically appear after a certain age. Enjoy a naturally gorgeous appearance and bid adieu to all skin problems. With our Nabota Botox treatment, which is a one-stop shop for reducing wrinkles by relaxing muscles, we at Elite Body Home have you covered."

        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "علاج بوتوكس نابوتا في دبي | تقليل التجاعيد بدون جراحة",
            "description": "نقدم بوتوكس نابوتا في دبي لتقليل الخطوط الدقيقة في الجبهة، تجاعيد العينين، وخطوط العبوس. حل غير جراحي للحصول على بشرة شبابية ناعمة.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/nabota-botox/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "علاج بوتوكس نابوتا في دبي | تقليل التجاعيد بدون جراحة",
                "description": "نقدم بوتوكس نابوتا في دبي لتقليل الخطوط الدقيقة في الجبهة، تجاعيد العينين، وخطوط العبوس. حل غير جراحي للحصول على بشرة شبابية ناعمة.",
                "url": "https://elitebodyhome.com/nabota-botox/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T09:11:06+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fgjgyi-scaled-large.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fgjgyi-scaled-large.jpg",
                "image_width": 1024,
                "image_height": 572,
                "image_alt": "بوتوكس نابوتا",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "علاج بوتوكس نابوتا في دبي | تقليل التجاعيد بدون جراحة",
                "description": "نقدم بوتوكس نابوتا في دبي لتقليل الخطوط الدقيقة في الجبهة، تجاعيد العينين، وخطوط العبوس. حل غير جراحي للحصول على بشرة شبابية ناعمة.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fgjgyi-scaled-large.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "بوتوكس نابوتا"],
        "hero": {
            "title": "علاج بوتوكس نابوتا في دبي",
            "subtitle": "خيارك الأمثل لإطلالة شابة ومنتعشة",
            "description": "اِسْتَعِيدي شبابك كما لم تفعليِ من قبل! تبدأ التجاعيد بالظهور مع التقدم في العمر ومشاكل البشرة وعلامات الشيخوخة، ودعِ هذه المشاكل واستمتعِ بإطلالة طبيعية وجميلة. نُقدم لك في ايليت بودي هوم علاج بوتوكس نابوتا، الحل الأمثل لتخفيف الخطوط الدقيقة والتجاعيد من خلال إرخاء العضلات."
        },
        "howItWorks": {
            "title": "ما هو بوتوكس نابوتا وكيف يعمل؟",
            "description": "يعد بوتوكس نابوتا علاج فعال لمكافحة التجاعيد وتحسين بعض حالات العضلات، وهو الصورة النقية من توكسين البوتولينوم، يستهدف عضلات الوجه المُسببة في التجاعيد التعبيرية. مع مرور الوقت، تظهر خطوط العبوس وخطوط الجبهه وتجاعيد العينين وغيرها، يعمل بوتوكس نابوتا على إرخاء هذه العضلات، مما يساعد على تقليل ظهور الخطوط والتجاعيد واستعادة مظهر أكثر شبابًا. يعد علاج بوتوكس نابوتا علاج شائع جدًا في دبي، ويُفضله الكثيرون. لدينا فريق من المتخصصين في ايليت بودي لتنفيذ الإجراء بأعلى مستوى من الدقة والاحترافية!"
        },
        "procedureSteps": {
            "heading": "خطوات إجراء بوتوكس نابوتا",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "نبدأ بجلسة استشارية يتم فيها تحليل ملامح وجهك بعناية، وبناءً على ذلك، تُحدد خطة علاجية مُخصصة تناسب ملامح وجهك واحتياجاتك وأهدافك التجميلية.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُنظف منطقة العلاج جيدًا، ثم يُستخدم كريم مخدر لضمان الراحة. الدقة هي الأساس وخاصة عند إجراء الحقن، لذا تُحدد النقاط المستهدفة بعناية لضمان حقن البوتوكس في المواقع المثالية.",
                    "icon": "fa-solid fa-prescription-bottle-medical"
                },
                {
                    "title": "الحقن",
                    "desc": "يُحقن البوتوكس في المناطق المستهدفة باستخدام إبرة دقيقة جدًا. تستغرق هذه الخطوة من 15 إلى 30 دقيقة فقط.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "العناية بعد العلاج",
                    "desc": "لا تنتهي الجلسة هنا، يُستخدم سيروم خاص لبشرة أكثر نعومة وترطيب.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "benefits": {
            "heading": "مميزات بوتوكس نابوتا",
            "subheading": "يعد علاج بوتوكس نابوتا للوجه بالكامل خيارك الأمثل للحصول على بشرة مشرقة وشابة دون القلق بشأن علامات التقدم في العمر، إليك أبرز مميزاته:",
            "para": "",
            "items": [
                {
                    "title": "تنعيم تجاعيد الوجه",
                    "desc": "التجاعيد من أكثر المشاكل شيوعًا، ولكن مع علاج بوتوكس نابوتا في دبي، يمكنك تخفيفها واستعادة مظهر شبابي رائع.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "منع ظهور تجاعيد جديدة",
                    "desc": "من أهم مميزات العلاج أنه يمنع ظهور تجاعيد جديدة، حيث يعمل على إرخاء العضلات المُسببة في الخطوط التعبيرية.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "غير جراحي وسهل الإجراء",
                    "desc": "لا داعِ للخضوع لأي جراحة! فقط إجراء بسيط وسريع يمنحك نتائج رائعة في وقت قصير.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "الحصول على نتائج سريعة",
                    "desc": "لا مزيد من الانتظار! تبدأ النتائج في الظهور خلال أيام قليلة، وتستمر لمدة 4 إلى 6 أشهر.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "إطلالة مشرقة تعني ثقة أكبر في حياتك الشخصية أو المهنية.",
                    "icon": "fa-solid fa-arrow-up"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "من هو المرشح المثالي لبوتوكس نابوتا؟",
            "para": "لا توجد معايير صارمة للعلاج، حيث يعد هذا العلاج مثالي لكل من يرغب في استعادة شباب بشرته والتخلص من علامات التقدم في العمر.",
            "items": [
                {
                    "title": "خيار غير جراحي",
                    "desc": "يعتبر خيار مثالي لمن لا يرغب في الخضوع لجراحة، ولكن يبحث عن نتائج رائعة ومظهر متجدد.",
                    "icon": "fa-solid fa-hand"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "يحافظ على التعبيرات الطبيعية للوجه، مما يتيح لك التمتع بإطلالة مشرقة دون تغيير ملامحك الأصلية.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "رعاية مُخصصة",
                    "desc": "لكل شخص رؤية جمالية فريدة، نضمن لك في ايليت بودي هوم علاجًا مُصممًا خصيصًا لتلبية احتياجاتك وتحقيق أهدافك الجمالية.",
                    "icon": "fa-solid fa-user-gear"
                }
            ]
        },
        "preparationTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "results": {
            "heading": "تمتع بنتائج مذهلة مع بوتوكس نابوتا",
            "subheading": "احصلِ على أفضل علاج بوتوكس نابوتا معنا، حيث نُقدم لك أفضل علاج بوتوكس نابوتا لضمان بشرة منتعشة وإطلالة شابة دون التأثير على تعابير وجهك الطبيعية. إليك أبرز النتائج التي يمكنك توقعها:",
            "para": "",
            "items": [
                {
                    "title": "بشرة صافية ومشرقة",
                    "desc": "قُولِي وداعًا للتجاعيد حول العينين والحاجبين وغيرها، ستقل بشكل ملحوظ بعد العلاج.",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "نتائج سريعة وملحوظة",
                    "desc": "تبدأ التغييرات في الظهور خلال 3 - 5 أيام عادة، بينما يمكن ملاحظة النتائج القصوى في غضون 7 - 10 أيام بعد العلاج.",
                    "icon": "fa-solid fa-gauge-high"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "تستمر نتائج علاج بوتوكس نابوتا من 4 إلى 6 أشهر، حسب نمط الحياة ونشاط العضلات، مما يمنحكِ شبابًا متجددًا مع الحد الأدنى من العناية.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "بشرة خالية من التجاعيد",
                    "desc": "يمنع العلاج ظهور التجاعيد المرتبطة بالتقدم في العمر، مما يساعدك في الحفاظ على مظهر شاب ومشرق لفترة أطول.",
                    "icon": "fa-solid fa-face-grin-beam"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح للعناية بعد العلاج",
            "subheading": "الخضوع للعلاج وحده غير كافٍ، لكن يتطلب عناية خاصة بعد الإجراء لتخفيف الآثار الجانبية والحصول على أفضل نتائج. إليك أهم النصائح التي يجب اتباعها:",
            "para": "",
            "items": [
                {
                    "title": "تجنّب لمس المنطقة المُعالجة",
                    "desc": "لا تلمس أو تدلّك المنطقة التي حُقنت لمدة 24 ساعة على الأقل، لتجنب انتشار البوتوكس للمناطق غير المستهدفة.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "البقاء في وضع مستقيم",
                    "desc": "احرص على البقاء في وضع مستقيم لمدة 4 ساعات لضمان تثبيت البوتوكس في مكانه الصحيح.",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "تجنب التمارين الشديدة",
                    "desc": "ينبغي الامتناع عن ممارسة التمارين الرياضية الشاقة، حيث يمكنها التأثير على النتائج.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "الامتناع عن الكحول لمدة 24 ساعة",
                    "desc": "يرفع الكحول من خطر الكدمات، لذا يُفضّل تجنبه قبل وبعد العلاج.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "تنظيف البشرة بلطف",
                    "desc": "استخدم غسولًا لطيفًا عند غسل الوجه، وتجنب الفرك القوي أو وضع الكريمات الثقيلة.",
                    "icon": "fa-solid fa-pump-soap"
                }
            ]
        },
        "faqData": {
            "heading": "أسئلة متكررة",
            "subheading": "",
            "items": [
                {
                    "question": "متى ستظهر نتائج بوتوكس نابوتا؟",
                    "answer": "تبدأ النتائج بالظهور عادة خلال 3 إلى 5 أيام، بينما يظهر التأثير الكامل في غضون أسبوع."
                },
                {
                    "question": "هل هناك فترة تعافٍ بعد هذا العلاج؟",
                    "answer": "على الإطلاق! يمكن لمعظم العملاء العودة إلى أنشطتهم اليومية فورًا بعد الإجراء."
                },
                {
                    "question": "هل يساعد بوتوكس نابوتا في منع ظهور تجاعيد جديدة؟",
                    "answer": "نعم، حيث يعمل على إرخاء العضلات التي تسبب الخطوط التعبيرية، مما يساعد في منع ظهور تجاعيد جديدة."
                },
                {
                    "question": "هل يوجد آثار جانبية لعلاج بوتوكس نابوتا؟",
                    "answer": "يمكن حدوث احمرار مؤقت أو تورم خفيف في مواقع الحقن، لكنها عادةً ما تختفي خلال بضع ساعات."
                }
            ]
        },
        "treatmentAreas2": [
            {
                "ar": "الخط الفكي",
                "title": "Jawline",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-5.jpg"
            },
            {
                "ar": "أشرطة العنق",
                "title": "Neck Bands",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-6.jpg"
            },
            {
                "ar": "خطوط الشفاه",
                "title": "Lip Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-1.jpg"
            }
        ],
        "treatmentAreas1": [
            {
                "ar": "الجبهة",
                "title": "Forehead",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-2.jpg"
            },
            {
                "ar": "خطوط التجهم",
                "title": "Frown Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-3.jpg"
            },
            {
                "ar": "خطوط الأرنب",
                "title": "Bunny Lines",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Nabota-Botox-Treatment-in-Dubai-EBH-clinic-4.jpg"
            }
        ]
    }

};
